import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Barter Search]'

export const setItemCollection = createAction(
    `${SOURCE} SetItemCollection`, props<{ itemCollection: any[] }>()
)

export const setFilterCriteria = createAction(
    `${SOURCE} SetFilterCriteria`, props<{ filterCriteria: any }>()
)

export const updateFilterCriteria = createAction(
    `${SOURCE} UpdateFilterCriteria`, props<{ criteriaFragment: any }>()
)

export const resetState = createAction(
    `${SOURCE} ResetState`,
)

export const noAction = createAction(
    `${SOURCE} No Action`,
)
